import styled from 'styled-components'

export const PageLeft = styled.div`
  font-size:14px;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`
export const PageRight = styled.div`
  flex: 1;
  font-size:14px !important;
  @media (max-width: 768px) {
    width: 100%;
    margin-left:0;
    margin-top:10px;
  }
`

